import type { IDxgVehicle } from '@makemydeal/dr-shared-types';
import type { VehicleField } from '../types/VehiclePickerProps';

/**
 * Generates vehicle field data for display in the selected vehicle info component
 * @param selectedVehicle - The vehicle object containing vehicle details
 * @returns Array of vehicle fields with labels, values, and test IDs
 */
export const getVehicleFields = (selectedVehicle: IDxgVehicle): VehicleField[] => {
    const { vin, stockNumber, priceCostDetails, odometerMileage, exteriorColor, interiorColor, powertrain } = selectedVehicle;

    return [
        { label: 'Vin', value: vin || 'N/A', testId: 'selected-vehicle-vin' },
        { label: 'Stock #', value: stockNumber || 'N/A', testId: 'selected-vehicle-stock' },
        {
            label: priceCostDetails?.retailPriceName || 'Selling Price',
            value: priceCostDetails?.retailPrice || 'N/A',
            testId: 'selected-vehicle-selling-price'
        },
        { label: 'Miles/Odometer', value: odometerMileage || 'N/A', testId: 'selected-vehicle-miles' },
        {
            label: 'Exterior/Interior Color',
            value: `${exteriorColor || 'N/A'}/${interiorColor || 'N/A'}`,
            testId: 'selected-vehicle-color'
        },
        {
            label: 'Drivetrain Desc',
            value: powertrain?.transmissionDetails?.description || 'N/A',
            testId: 'selected-vehicle-drivetrain'
        }
    ];
};
